// extracted by mini-css-extract-plugin
module.exports = {"Button":"EditableTableRow_Button__1rYWG"};